"use client"

import { cn } from '@/lib/utils';
import { type Prisma } from '@prisma/client';
import { Check } from 'lucide-react';
import React, { useState, useMemo, useCallback } from 'react';
import GroupDateShowSlider from './group-date-show';

type BatchesType = Prisma.BatchGetPayload<{
    include: {
        available_dates: {
            include: {
                mode_of_transports: true
            }
        },
    }
}>

interface TripDateShowerProps {
    batches: BatchesType[]
}

export default function TripDateShower({ batches }: TripDateShowerProps) {
    const [selectedCity, setSelectedCity] = useState<string>(batches.length > 0 ? batches[0]?.city ?? '' : '');

    const getAvailableDates = useCallback(() => {
        const selectedBatch = batches.find((batch) => batch.city === selectedCity);
        return selectedBatch ? selectedBatch.available_dates : [];
    }, [batches, selectedCity]);

    const availableDates = useMemo(() => getAvailableDates(), [getAvailableDates]);

    const handleCityChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedCity(event.target.value);
    }, []);

    return (
        <div>
            <div>
                <h3 className="font-bold mb-2">Select a City:</h3>
                <div className="flex flex-row flex-wrap gap-2.5">
                    {batches.map((batch) => (
                        <div key={batch.city} className="flex w-fit">
                            <input
                                type="radio"
                                id={batch.city}
                                value={batch.city}
                                checked={selectedCity === batch.city}
                                onChange={handleCityChange}
                                className="mr-2 sr-only"
                            />
                            <label htmlFor={batch.city} className="flex items-center px-2.5 py-1 border border-zinc-300 rounded bg-custom-primary-shade w-fit cursor-pointer">
                                <div className={cn("h-4 w-4 rounded-full mr-2", selectedCity === batch.city ? "bg-green-400" : "bg-white")}>
                                    {selectedCity === batch.city && <Check className="h-full w-full text-white scale-[0.88]" />}
                                </div>
                                <p>{batch.city}</p>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
            <div className="w-full shrink-0">
                <h3 className="font-bold my-2">Available Dates for {selectedCity}:</h3>
                <GroupDateShowSlider availableDates={availableDates}/>
            </div>
        </div>
    )
}
